import React from 'react';

import { Separator as StyledSeparator } from './Separator.styles';

const Separator = ({ spacing, style }) => <StyledSeparator spacing={spacing} style={style} />;

export default Separator;
